export const DEFAULT_IDENTITY_PROVIDER = 'SRC';
